import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  TextField,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import HttpService from '../../../hooks/Https-services';
import { API_ROUTES } from '../../../utils/constant';
import { DateRangePicker } from 'rsuite';
import moment from 'moment';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
type ChartSeries = {
  name: string;
  data: number[];
};

type ChartData = {
  series: ChartSeries[];
  categories: string[];
};

const ReportChart = (props: {
  dateRangeReport: any;
  selectedTeamsKeys: any;
  selectedPriorityKeys: any;
  selectedTeams: any;
  isTeamLoaded: any;
}) => {
  const {
    dateRangeReport,
    selectedTeamsKeys,
    selectedPriorityKeys,
    selectedTeams,
    isTeamLoaded,
  } = props;

  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState<ChartData>({
    series: [],
    categories: [],
  });

  const fetchChartData = useCallback(async () => {
    setLoading(true);
    try {
      const query: any = {};
      if (dateRangeReport) {
        query.startDate = moment(dateRangeReport[0]).format('DD-MM-YYYY');
        query.endDate = moment(dateRangeReport[1]).format('DD-MM-YYYY');
      }
      if (selectedTeamsKeys.length > 0) {
        query.teamIds = selectedTeamsKeys.join(',');
      }
      if (selectedPriorityKeys.length > 0) {
        query.priority = selectedPriorityKeys.join(',');
      }

      const response = await HttpService.get(
        `${API_ROUTES.reportData}?${new URLSearchParams(query).toString()}`
      );
      const apiData: any = response.data.data;
      // Transform API data

      const categories: string[] = apiData.map(
        (item: { date: any }) => item.date
      );
      const series = [
        {
          name: 'MINOR',
          data: apiData.map((item: { MINOR: any }) => item.MINOR),
        },
        {
          name: 'NORMAL',
          data: apiData.map((item: { NORMAL: any }) => item.NORMAL),
        },
        {
          name: 'MAJOR',
          data: apiData.map((item: { MAJOR: any }) => item.MAJOR),
        },
        {
          name: 'CRITICAL',
          data: apiData.map((item: { CRITICAL: any }) => item.CRITICAL),
        },
        {
          name: 'SHOW_STOPPER',
          data: apiData.map((item: { SHOW_STOPPER: any }) => item.SHOW_STOPPER),
        },
      ];

      setChartData({ series, categories });
    } catch (error) {
      console.error('Error fetching chart data:', error);
    } finally {
      setLoading(false);
    }
  }, [selectedTeams, isTeamLoaded, dateRangeReport, selectedPriorityKeys]);

  useEffect(() => {
    if (isTeamLoaded) {
      fetchChartData();
    }
  }, [fetchChartData]);

  const chartOptions: any = {
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: true,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          borderRadiusApplication: 'end',
          borderRadiusWhenStacked: 'last',
          dataLabels: {
            total: {
              enabled: true,
              style: {
                fontSize: '13px',
                fontWeight: 900,
              },
            },
          },
        },
      },
      xaxis: {
        type: 'date',
        categories: chartData.categories,
      },
      legend: {
        position: 'right',
        offsetY: 40,
      },
      fill: {
        opacity: 1,
      },
      title: {
        text: 'Game completed',
        align: 'left',
        style: {
          fontSize: '16px',
        },
      },
      colors: ['#eeeeee', '#dbf2ff', '#eb6f33', '#d30584', '#e30000'],
    },
  };

  return (
    <>
      {!loading && chartData.series.length > 0 ? (
        <ReactApexChart
          options={chartOptions.options}
          series={chartData.series}
          type="bar"
          height={600}
        />
      ) : (
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </>
  );
};

export default ReportChart;
